export default __webpack_public_path__ + "static/media/aditional_dot_remark.7f65cb68.svg";